import { render, staticRenderFns } from "./aviso-editable.vue?vue&type=template&id=6efd7864&scoped=true&"
import script from "./aviso-editable.component.ts?vue&type=script&lang=ts&"
export * from "./aviso-editable.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6efd7864",
  null
  
)

export default component.exports